import Handlebars from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import currentWidgetDetails from "utilities/platform/widget-details";
export default class Templates {
    compile(templateString) {
        return Handlebars.compile(templateString);
    };
};